export default {
  'application.title': 'Pension Calculator – Pension',
  'application.title.stegvisning.start': 'Start – Pension Calculator',
  'application.title.stegvisning.sivilstand':
    'Marital Status – Pension Calculator',
  'application.title.stegvisning.utenlandsopphold':
    'Time lived Abroad – Pension Calculator',
  'application.title.stegvisning.afp': 'AFP – Pension Calculator',
  'application.title.stegvisning.ufoeretryg_AFP':
    'Disability Benefit and AFP – Pension Calculator',
  'application.title.stegvisning.samtykke_offentlig_AFP':
    'Consent for Public AFP – Pension Calculator',
  'application.title.stegvisning.samtykke': 'Consent – Pension Calculator',
  'application.title.stegvisning.uventet_feil':
    'Unexpected Error – Pension Calculator',
  'application.title.stegvisning.kalkulator_virker_ikke': 'MANGLER_TEKST',
  'application.title.securityLevel_feil': 'MANGLER_TEKST',
  'application.title.beregning': 'Calculation – Pension Calculator',
  'application.title.forbehold': 'Reservation – Pension Calculator',
  'application.title.personopplysninger':
    'Personal Data in basic calculator – Pension Calculator',
  'application.global.external_link': 'opens in a new tab',
  'application.global.retry': 'Try Again',
  'pageframework.title': 'Pension Calculator',
  'pageframework.loading': 'Please wait while we retrieve the information.',
  'error.securityLevel.title': 'MANGLER_TEKST',
  'error.securityLevel.ingress': 'MANGLER_TEKST',
  'error.securityLevel.primary_button': 'MANGLER_TEKST',
  'error.securityLevel.secondary_button': 'MANGLER_TEKST',
  'error.fullmakt.title':
    'You cannot use the calculator on behalf of this user',
  'error.fullmakt.ingress':
    'Proceed to see what actions you can take on behalf of this user or switch to another user.',
  'error.fullmakt.bytt_bruker': 'Proceed to Switch User',
  'error.global.title': 'Oops! An unexpected error has occurred.',
  'error.global.ingress':
    'We are working to fix the error. Please try again later.',
  'error.global.button': 'Cancel',
  'error.du_kan_ikke_bruke_enkel_kalkulator':
    'Unfortunately, you cannot use this calculator',
  'error.404.title': 'Oops! The page you are looking for does not exist.',
  'error.404.list_item1':
    'If you entered the address directly in your browser, check to see if it is spelled correctly.',
  'error.404.list_item2':
    'If you clicked on a link, it is incorrect or outdated.',
  'error.404.button.link_1': 'Go to the pension calculator',
  'error.404.button.link_2': 'Read about pensions',
  'error.virker_ikke.title': 'MANGLER_TEKST',
  'error.virker_ikke.ingress': 'MANGLER_TEKST',
  'error.virker_ikke.link': 'MANGLER_TEKST',
  'error.virker_ikke.button': 'MANGLER_TEKST',
  'error.apoteker_warning': 'MANGELR_TEKST',
  'landingsside.for.deg.som.kan.logge.inn': 'MANGLER_TEKST',
  'landingsside.for.deg.foedt.foer.1963': 'For those born before 1963',
  'landingsside.du.maa.bruke.detaljert':
    'You must use our detailed calculator. It provides an estimate of',
  'landingsside.velge_mellom_detaljert_og_enkel':
    'In the pension calculator, you can get an estimate of',
  'landingsside.button.enkel_kalkulator_utlogget':
    'Log in to the pension calculator',
  'landingsside.button.enkel_kalkulator': 'Pension Calculator',
  'landingsside.text.uinnlogget_kalkulator': 'For those who cannot log in',
  'landingsside.button.uinnlogget_kalkulator': 'Unauthenticated calculator',
  'landingsside.body.uinnlogget_kalkulator':
    'You can use our unauthenticated calculator. It does not retrieve or store any information about you. You must find and enter all the information yourself. The calculator gives you an estimate of retirement pension from the National Insurance Scheme (Nav) and AFP (contractual early retirement pension) in the private sector.',
  'landingsside.link.personopplysninger':
    'Personal data used in the pension calculator',
  'stegvisning.radio_ja': 'Yes',
  'stegvisning.radio_nei': 'No',
  'stegvisning.neste': 'Next',
  'stegvisning.tilbake': 'Back',
  'stegvisning.avbryt': 'Cancel',
  'stegvisning.tilbake_start': 'Back to start',
  'stegvisning.tilbake_start.modal.title':
    'If you go back to start, you will lose all your choices.',
  'stegvisning.tilbake_start.modal.bekreft': 'Go back to start',
  'stegvisning.tilbake_start.modal.avbryt': 'Cancel',
  'stegvisning.fremtidigvedtak.alert': 'MANGLER_TEKST',
  'stegvisning.start.title': 'Hello',
  'stegvisning.start.endring.ingress_1a': `You currently have <strong>{grad} % retirement pension</strong>{
      ufoeretrygd,  select,     0 {} other { and <strong>{ufoeretrygd} % disability benefits</strong>}}{
      afpPrivat,    select, false {} other { and <strong>AFP in the private sector</strong>}}{
      afpOffentlig, select, false {} other { and <strong>AFP in the public sector</strong>}}. `,
  'stegvisning.start.endring.ingress_1b.uten_fremtidig':
    'Here you can check what you can receive if you want to change your retirement pension.{br}{br}',
  'stegvisning.start.endring.ingress_1b.med_fremtidig': 'MANGLER_TEKST',
  'stegvisning.start.ingress.pre2025_offentlig_afp': 'MANGLER_TEKST',
  'stegvisning.start.endring.ingress.pre2025_offentlig_afp_fremtidig':
    'MANGLER_TEKST',
  'stegvisning.start.ingress':
    'Welcome to the pension calculator which can show you:',
  'stegvisning.start.list_item1': 'retirement pension (Nav)',
  'stegvisning.start.list_item2': 'AFP (contractual pension)',
  'stegvisning.start.list_item3': 'pension agreements (employers, etc.)',
  'stegvisning.start.endring.ingress_2':
    'You must answer all the following questions.',
  'stegvisning.start.ingress_2':
    'To get an estimate of your pension, you must answer all the following questions.',
  'stegvisning.start.button': 'Get Started',
  'stegvisning.start.link': 'Personal data used in the pension calculator',
  'stegvisning.start_brukere_fyllt_75.title': 'MANGLER_TEKST',
  'stegvisning.start_brukere_fyllt_75.ingress': 'MANGLER_TEKST',
  'stegvisning.start_brukere_fyllt_75.button': 'MANGLER_TEKST',
  'stegvisning.start_brukere_fyllt_75.avbryt': 'MANGLER_TEKST',
  'stegvisning.utenlandsopphold.title': 'Time abroad',
  'stegvisning.utenlandsopphold.ingress':
    'If you have lived or worked more than 5 years outside Norway between the age of 16 and the withdrawal of your pension, it may affect the amount of your retirement pension.',
  'stegvisning.utenlandsopphold.radio_label':
    'Have you lived or worked outside Norway for more than 5 years?',
  'stegvisning.utenlandsopphold.radio_label.description':
    'From the age of 16 until you withdraw your pension',
  'stegvisning.utenlandsopphold.radio_ja': 'Yes',
  'stegvisning.utenlandsopphold.radio_nei': 'No',
  'stegvisning.utenlandsopphold.validation_error':
    'You must answer whether you have lived or worked outside Norway for more than 5 years after the age of 16.',
  'stegvisning.utenlandsopphold.mangler_opphold.validation_error':
    'You must add at least one stay or answer "No" to whether you have lived or worked outside Norway for more than 5 years.',
  'stegvisning.utenlandsopphold.ingress.bottom':
    'If you will not be living in Norway when you receive your pension, you should investigate the rules for export. The calculator does not evaluate whether you have the right to receive your full retirement pension if you reside outside Norway.',
  'stegvisning.utenlandsopphold.oppholdene.title': 'Your stays outside Norway',
  'stegvisning.utenlandsopphold.oppholdene.description':
    'Add completed and planned stays',
  'stegvisning.utenlandsopphold.oppholdene.description.periode': 'Period: ',
  'stegvisning.utenlandsopphold.oppholdene.description.periode.varig_opphold':
    '(Permanent Stay)',
  'stegvisning.utenlandsopphold.oppholdene.description.har_jobbet': 'Worked: ',
  'stegvisning.utenlandsopphold.oppholdene.description.har_jobbet.ja': 'Yes',
  'stegvisning.utenlandsopphold.oppholdene.description.har_jobbet.nei': 'No',
  'stegvisning.utenlandsopphold.oppholdene.button.legg_til': 'Add Stay',
  'stegvisning.utenlandsopphold.oppholdene.button.legg_til_nytt':
    'Add New Stay',
  'stegvisning.utenlandsopphold.oppholdene.button.endre': 'Edit Stay',
  'stegvisning.utenlandsopphold.oppholdene.button.slette': 'Delete Stay',
  'utenlandsopphold.om_oppholdet_ditt_modal.title': 'About Your Stay',
  'utenlandsopphold.om_oppholdet_ditt_modal.button.legg_til': 'Add Stay',
  'utenlandsopphold.om_oppholdet_ditt_modal.button.oppdater': 'Update Stay',
  'utenlandsopphold.om_oppholdet_ditt_modal.button.avbryt': 'Cancel',
  'utenlandsopphold.om_oppholdet_ditt_modal.button.avbryt_endring':
    'Cancel Change',
  'utenlandsopphold.om_oppholdet_ditt_modal.land.label': 'Select Country',
  'utenlandsopphold.om_oppholdet_ditt_modal.har_jobbet.label':
    'Did you work in {land}?',
  'utenlandsopphold.om_oppholdet_ditt_modal.har_jobbet.description':
    'If you worked during parts of your stay, you should add the periods you worked and the periods you did not work as two separate stays.',
  'utenlandsopphold.om_oppholdet_ditt_modal.har_jobbet.radio_ja': 'Yes',
  'utenlandsopphold.om_oppholdet_ditt_modal.har_jobbet.radio_nei': 'No',
  'utenlandsopphold.om_oppholdet_ditt_modal.startdato.label':
    'Enter Start Date',
  'utenlandsopphold.om_oppholdet_ditt_modal.startdato.description':
    'If you do not know the exact dates, enter approximate dates.',
  'utenlandsopphold.om_oppholdet_ditt_modal.sluttdato.label': 'Enter End Date',
  'utenlandsopphold.om_oppholdet_ditt_modal.sluttdato.description':
    'For permanent stay, leave this field empty.',
  'utenlandsopphold.om_oppholdet_ditt_modal.land.validation_error':
    'You must select a country for your stay.',
  'utenlandsopphold.om_oppholdet_ditt_modal.arbeidet_utenlands.validation_error':
    'You must answer "Yes" or "No" to whether you worked during your stay.',
  'utenlandsopphold.om_oppholdet_ditt_modal.dato.validation_error.format':
    'Enter day, month, and year as DD.MM.YYYY.',
  'utenlandsopphold.om_oppholdet_ditt_modal.dato.validation_error.after_max':
    'End date cannot be later than {maxDato}.',
  'utenlandsopphold.om_oppholdet_ditt_modal.startdato.validation_error.required':
    'You must provide a start date for your stay.',
  'utenlandsopphold.om_oppholdet_ditt_modal.startdato.validation_error.before_min':
    'Start date cannot be before your birth date.',
  'utenlandsopphold.om_oppholdet_ditt_modal.sluttdato.validation_error.before_min':
    'End date cannot be before start date.',
  'utenlandsopphold.om_oppholdet_ditt_modal.sluttdato.validation_error.required':
    'You can only have one permanent stay. Please fill out an end date for your stay.',
  'utenlandsopphold.om_oppholdet_ditt_modal.overlappende_perioder.validation_error.ikke_avtaleland':
    'You have already registered that you have lived in {land} from {periodestart} to {periodeslutt}. You cannot have overlapping stays with the country {land}.',
  'utenlandsopphold.om_oppholdet_ditt_modal.overlappende_perioder.validation_error.ulike_land':
    'You have already registered that you have lived in {land} from {periodestart} to {periodeslutt}. You cannot have overlapping stays in two different countries.',
  'utenlandsopphold.om_oppholdet_ditt_modal.overlappende_perioder.validation_error.bostatus':
    'You have already registered that you have lived in {land} from {periodestart} to {periodeslutt}. You cannot have overlapping residence stays.',
  'utenlandsopphold.om_oppholdet_ditt_modal.overlappende_perioder.validation_error.jobbstatus':
    'You have already registered that you have worked in {land} from {periodestart} to {periodeslutt}. You cannot have overlapping work periods.',
  'utenlandsopphold.slette_modal.title':
    'Are you sure you want to delete your stay?',
  'utenlandsopphold.slette_modal.button.avbryt': 'Cancel',
  'utenlandsopphold.slette_modal.button.slett': 'Delete Stay',
  'stegvisning.samtykke_pensjonsavtaler.title': 'Pension Agreements',
  'stegvisning.samtykke_pensjonsavtaler.ingress': 'MANGLER_TEKST',
  'stegvisning.samtykke_pensjonsavtaler.radio_label':
    'Should we retrieve your pension agreements?',
  'stegvisning.samtykke_pensjonsavtaler.radio_description': 'MANGLER_TEKST',
  'stegvisning.samtykke_pensjonsavtaler.radio_ja': 'Yes',
  'stegvisning.samtykke_pensjonsavtaler.radio_nei': 'No, continue without',
  'stegvisning.samtykke_pensjonsavtaler.validation_error':
    'You must answer whether you want us to retrieve your pension agreements.',
  'stegvisning.afp.title': 'AFP (contractual pension)',
  'stegvisning.afp.ingress':
    'To receive AFP, your employer must have such an agreement, and you must qualify for it.',
  'stegvisning.afp.readmore_offentlig_list_title': 'AFP in the public sector:',
  'stegvisning.afp.radio_label': 'Do you have a right to AFP?',
  'stegvisning.afp.radio_ja_offentlig': 'Yes, in the public sector',
  'stegvisning.afp.radio_ja_privat': 'Yes, in the private sector',
  'stegvisning.afp.radio_nei': 'No',
  'stegvisning.afp.radio_vet_ikke': 'Don’t know',
  'stegvisning.afp.alert_vet_ikke':
    'If you are unsure, you should check with your employer.',
  'stegvisning.afp.validation_error':
    'You must answer whether you have a right to AFP.',
  'stegvisning.ufoere.title':
    'Disability Benefits and AFP (contractual pension)',
  'stegvisning.ufoere.info':
    'Before turning 62, you must choose between receiving AFP or retaining disability benefits. {br}{br} AFP and disability benefits cannot be combined. If you do not inform us, you will lose your right to AFP (but retain disability benefits).',
  'stegvisning.ufoere.ingress':
    'You can get help assessing your options. Contact your occupational pension scheme if you work in the public sector. <planleggePensjonLink>Contact Nav</planleggePensjonLink> if you work in the private sector.',
  'stegvisning.samtykke_offentlig_afp.title':
    'Consent for Nav to Calculate AFP (contractual pension)',
  'stegvisning.samtykke_offentlig_afp.ingress':
    'Your occupational pension scheme is responsible for AFP in the public sector. They will assess if you meet the conditions and make the final calculation when you apply for AFP. Contact them if you have questions.{br}{br}Nav does not assess whether you have the right to an AFP, but can give you a preliminary calculation of the AFP in this calculator.',
  'stegvisning.samtykke_offentlig_afp.radio_label':
    'Do you want Nav to calculate AFP for you?',
  'stegvisning.samtykke_offentlig_afp.radio_description':
    'The consent only applies for calculations in this calculator, until you log out.',
  'stegvisning.samtykke_offentlig_afp.radio_ja': 'Yes',
  'stegvisning.samtykke_offentlig_afp.radio_nei': 'No, continue without',
  'stegvisning.samtykke_offentlig_afp.validation_error':
    'You must answer whether you want Nav to calculate AFP for you.',
  'stegvisning.sivilstand.title': 'Your Marital Status',
  'stegvisning.sivilstand.ingress_ukjent': 'MANGLER_TEKST',
  'stegvisning.sivilstand.ingress_1': 'You are registered as ',
  'stegvisning.sivilstand.ingress_2':
    ' in the National Population Register. If you have a partner or spouse, it may affect the calculation.',
  'stegvisning.sivilstand.select_label': 'MANGLER_TEKST',
  'stegvisning.sivilstand.select_description_ukjent': 'MANGLER_TEKST',
  'stegvisning.sivilstand.select_description': 'MANGLER_TEKST',
  'stegvisning.sivilstand.radio_epsHarPensjon_label': 'MANGLER_TEKST',
  'stegvisning.sivilstand.radio_epsHarPensjon_description': 'MANGLER_TEKST',
  'stegvisning.sivilstand.radio_epsHarInntektOver2G_label': 'MANGLER_TEKST',
  'stegvisning.sivilstand.radio_epsHarInntektOver2G_description':
    'MANGLER_TEKST',
  'stegvisning.sivilstand.radio_label': 'Do you have a partner or spouse?',
  'stegvisning.sivilstand.radio_ja': 'Yes',
  'stegvisning.sivilstand.radio_nei': 'No',
  'stegvisning.sivilstand.select_validation_error': 'MANGELR_TEKST',
  'stegvisning.sivilstand.epsHarPensjon.validation_error': 'MANGLER_TEKST',
  'stegvisning.sivilstand.epsHarInntektOver2G.validation_error':
    'MANGLER_TEKST',
  'stegvisning.sivilstand.ektefellen': 'MANGLER_TEKST',
  'stegvisning.sivilstand.samboeren': 'MANGLER_TEKST',
  'stegvisning.sivilstand.partneren': 'MANGLER_TEKST',
  'agepicker.validation_error.aar': 'You must select year and month',
  'agepicker.validation_error.maaneder': 'You must select month',
  'string.og': 'and',
  'string.fra': 'from',
  'string.til': 'to',
  'alder.md': 'mo.',
  'alder.maaned': 'month',
  'alder.maaneder': 'months',
  'alder.aar': 'years',
  'alder.aar_livsvarig': 'years (lifelong)',
  'afp.offentlig': 'Public',
  'afp.privat': 'Private',
  'afp.nei': 'No',
  'afp.vet_ikke': 'Don’t know',
  'sivilstand.GIFT': 'Married',
  'sivilstand.UGIFT': 'Unmarried',
  'sivilstand.REGISTRERT_PARTNER': 'Registered Partner',
  'sivilstand.ENKE_ELLER_ENKEMANN': 'Widow/Widower',
  'sivilstand.SKILT': 'Divorced',
  'sivilstand.SEPARERT': 'Separated',
  'sivilstand.SEPARERT_PARTNER': 'Separated Partner',
  'sivilstand.SAMBOER': 'MANGLER_TEKST',
  'sivilstand.SKILT_PARTNER': 'Divorced Partner',
  'sivilstand.GJENLEVENDE_PARTNER': 'Surviving Partner',
  'sivilstand.med_samboer': 'with Partner',
  'sivilstand.uten_samboer': 'without Partner',
  'tidligstmuliguttak.ingress_1':
    'Your calculation shows that you can withdraw <nowrap>100%</nowrap> of your retirement pension from the age of ',
  'tidligstmuliguttak.1963.ingress_2':
    ' If you delay your withdrawal, your annual pension will increase.',
  'tidligstmuliguttak.1964.ingress_2':
    ' It may be later due to the increased retirement age.',
  'tidligstmuliguttak.pre2025OffentligAfp.ingress': 'MANGLER_TEKST',
  'tidligstmuliguttak.pre2025OffentligAfp.avansert_link': 'MANGLER_TEKST',
  'tidligstmuliguttak.info_omstillingsstoenad_og_gjenlevende':
    'retirement pension cannot be combined with a survivor´s pension or adjustment benefits. If you wish to withdraw retirement pension before 67, you must forfeit the survivor´s pension or adjustment benefit when you withdraw your retirement pension. If you have questions, you can contact us at <nowrap>{link}</nowrap>.',
  'tidligstmuliguttak.error':
    'In Advanced, you can choose a more accurate pension age.',
  'omufoeretrygd.hel.ingress':
    'You have <nowrap>100 %</nowrap> disability benefits. Here you can calculate <nowrap>100 %</nowrap> retirement pension from 67 years.{br}{br}Upcoming legal changes will gradually increase the retirement age for those born in 1964 or later.',
  'omufoeretrygd.gradert.ingress':
    'You have <nowrap>{grad} %</nowrap> disability benefits. Here you can calculate <nowrap>100 %</nowrap> retirement pension from 67 years. If you want to calculate withdrawal before 67, you must go to {link}.{br}{br}Upcoming legal changes will gradually increase the retirement age for those born in 1964 or later.',
  'omufoeretrygd.gradert.ingress.afp': 'MANGLER_TEKST',
  'omufoeretrygd.avansert_link': 'Advanced',
  'velguttaksalder.title': 'When do you want to withdraw retirement pension?',
  'velguttaksalder.endring.title':
    'When do you want to change your retirement pension?',
  'velguttaksalderafp.title': 'MANGLER_TEKST',
  'beregning.intro.title': 'MANGLER_TEKST',
  'beregning.intro.title.endring': 'MANGLER_TEKST',
  'beregning.intro.description_1': 'MANGLER_TEKST',
  'beregning.intro.description_1.endring': 'MANGLER_TEKST',
  'beregning.intro.description_2.gradert_UT.med_afp': 'MANGLER_TEKST',
  'beregning.intro.description_2.gradert_UT.uten_afp': 'MANGLER_TEKST',
  'beregning.intro.description_2.hel_UT': 'MANGLER_TEKST',
  'beregning.pdf.ingress': 'MANGLER_TEKST',
  'beregning.pdf.button': 'MANGLER_TEKST',
  'beregning.avansert.rediger.beregningsvalg.description': 'MANGLER_TEKST',
  'beregning.avansert.rediger.beregningsvalg.om_valget_link': 'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.beregningsvalg.label': 'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.beregningsvalg.uten_afp.label':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.beregningsvalg.med_afp.label':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.afp_etterfulgt_av_ap.title': 'MANGLER_TEKST',
  'beregning.avansert.rediger.beregningsvalg.med_afp.title': 'MANGLER_TEKST',
  'beregning.avansert.rediger.beregningsvalg.med_afp.description':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.pre2025_offentlig_afp.alert': 'MANGLER_TEKST',
  'beregning.toggle.enkel': 'Simple',
  'beregning.toggle.avansert': 'Advanced',
  'beregning.loading': 'Please wait while we calculate your pension.',
  'beregning.error':
    'Unfortunately, we could not calculate your pension right now.',
  'beregning.livsvarig': 'lifelong',
  'beregning.lav_opptjening.aar':
    'You do not have enough accrual to start withdrawing at {startAar} years{startMaaned}. Try a higher age.',
  'beregning.button.faerre_aar': 'Fewer Years',
  'beregning.button.flere_aar': 'More Years',
  'beregning.pensjonsavtaler.alert.endring':
    'Pension agreements from employers and personal savings are not included in the calculation.',
  'beregning.pensjonsavtaler.alert.stoettes_ikke':
    'The calculation may not show everything. You may be entitled to a public sector occupational pension. Read more under <scrollTo>pension agreements</scrollTo>.',
  'beregning.pensjonsavtaler.alert.privat.error':
    'This calculation may not show everything. We could not retrieve your private pension agreements. You may also be entitled to public occupational pension. See why under <scrollTo>pension agreements</scrollTo>.',
  'beregning.pensjonsavtaler.alert.offentlig.error':
    'This calculation may not show everything. We could not check whether you have pension agreements in the public sector. See why under <scrollTo>pension agreements</scrollTo>.',
  'beregning.pensjonsavtaler.alert.privat_og_offentlig.error':
    'This calculation may not show everything. We could not check whether you have pension agreements in the public sector and we could not retrieve <scrollTo>your private pension agreements</scrollTo>.',
  'beregning.pensjonsavtaler.alert.avtaler_foer_alder':
    'You have pension agreements that start before the age you selected. See periods under <scrollTo>Pension Agreements</scrollTo>.',
  'beregning.title': 'MANGLER_TEKST',
  'beregning.alert.inntekt':
    'Because you have changed your income, your pension accrual changes.',
  'beregning.highcharts.informasjon_klikk': 'MANGLER_TEKST',
  'beregning.highcharts.title': 'Calculation',
  'beregning.highcharts.ingress': 'MANGLER_TEKST',
  'beregning.highcharts.alt_tekst':
    'Annual income and pension after withdrawal in kroner.',
  'beregning.highcharts.xaxis': 'Annual Income and Pension after Withdrawal',
  'beregning.highcharts.yaxis': 'Currency',
  'beregning.highcharts.yaxis.mobile': 'Thousand currency',
  'beregning.highcharts.serie.inntekt.name': 'Pensionable income',
  'beregning.highcharts.serie.tp.name': 'Pension Agreements (employers, etc.)',
  'beregning.highcharts.serie.afp.name': 'AFP (contractual pension)',
  'beregning.highcharts.serie.alderspensjon.name': 'retirement pension (Nav)',
  'beregning.highcharts.tooltip.inntekt': 'Income when you are',
  'beregning.highcharts.tooltip.pensjon': 'Pension when you are',
  'beregning.highcharts.tooltip.inntekt_og_pensjon':
    'Income and pension when you are',
  'beregning.tabell.lukk': 'Close calculation table',
  'beregning.tabell.vis': 'Show calculation table',
  'beregning.tabell.sum': 'Total',
  'beregning.detaljer.lukk': 'MANGLER_TEKST',
  'beregning.detaljer.vis': 'MANGLER_TEKST',
  'beregning.detaljer.grunnpensjon.heltUttak.title': 'MANGLER_TEKST',
  'beregning.detaljer.grunnpensjon.gradertUttak.title': 'MANGLER_TEKST',
  'beregning.detaljer.grunnpensjon.afp.table.title': 'MANGLER_TEKST',
  'beregning.detaljer.grunnpensjon.table.title': 'MANGLER_TEKST',
  'beregning.detaljer.grunnpensjon.pre2025OffentligAfp.title': 'MANGLER_TEKST',
  'beregning.detaljer.afpPrivat.heltUttak.title': 'MANGLER_TEKST',
  'beregning.detaljer.afpPrivat.gradertUttak.title': 'MANGLER_TEKST',
  'beregning.detaljer.afpOffentlig.uttak.title': 'MANGLER_TEKST',
  'beregning.detaljer.OpptjeningDetaljer.table.title': 'MANGLER_TEKST',
  'beregning.detaljer.OpptjeningDetaljer.kap19.table.title': 'MANGLER_TEKST',
  'beregning.detaljer.OpptjeningDetaljer.kap20.table.title': 'MANGLER_TEKST',
  'beregning.detaljer.OpptjeningDetaljer.afpPrivat.table.title':
    'MANGLER_TEKST',
  'beregning.detaljer.OpptjeningDetaljer.pre2025OffentligAfp.table.title':
    'MANGLER_TEKST',
  'beregning.avansert.link.endre_valgene_dine': 'Change your choices',
  'beregning.avansert.link.endre_avanserte_valg': 'Change advanced choices',
  'beregning.avansert.link.om_vilkaar_for_afp': 'MANGLER_TEKST',
  'beregning.avansert.endring_banner.title': 'MANGLER_TEKST',
  'beregning.avansert.endring_banner.kr_md': 'kr/mo.',
  'beregning.avansert.maanedsbeloep.table_title': 'MANGLER_TEKST',
  'beregning.avansert.maanedsbeloep.box_title': 'MANGLER_TEKST',
  'beregning.avansert.maanedsbeloep.afp': 'MANGLER_TEKST',
  'beregning.avansert.maanedsbeloep.pensjonsavtaler': 'MANGLER_TEKST',
  'beregning.avansert.maanedsbeloep.alderspensjon': 'MANGLER_TEKST',
  'beregning.avansert.maanedsbeloep.sum': 'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_frem_til_uttak.label':
    'Pensionable income until pension',
  'beregning.avansert.rediger.inntekt_frem_til_endring.label':
    'Pensionable income until change',
  'beregning.avansert.rediger.inntekt_frem_til_uttak.description_ufoere':
    'Without disability benefits and disability pension.',
  'beregning.avansert.rediger.inntekt_frem_til_uttak.description':
    'kr per year before tax',
  'beregning.avansert.rediger.uttaksgrad.label':
    'How much retirement pension do you want to withdraw?',
  'beregning.avansert.rediger.uttaksgrad.description':
    'Choose withdrawal degree',
  'beregning.avansert.rediger.uttaksgrad.endring.description':
    'Choose new withdrawal degree',
  'beregning.avansert.rediger.radio.inntekt_vsa_helt_uttak':
    'Do you expect to have income at the same time as you withdraw <nowrap>100 %</nowrap> pension?',
  'beregning.avansert.rediger.radio.inntekt_vsa_helt_uttak.description':
    'You can earn as much as you want while withdrawing pension.',
  'beregning.avansert.rediger.radio.inntekt_vsa_helt_uttak.description.validation_error':
    'You must answer whether you expect to have income while you withdraw <nowrap>100 %</nowrap> pension.',
  'beregning.avansert.rediger.radio.inntekt_vsa_afp': 'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_afp.description':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.uttaksgrad.validation_error':
    'You must choose how much retirement pension you wish to withdraw.',
  'beregning.avansert.rediger.uttaksgrad.ufoeretrygd.validation_error':
    'You must lower the withdrawal degree so that the degrees of retirement pension and disability benefits do not exceed 100 % together. After 67, you can choose 100 % withdrawal.',
  'beregning.avansert.rediger.inntekt_vsa_helt_uttak.beloep.validation_error':
    'You must fill in expected income at the same time as you withdraw <nowrap>100 %</nowrap> pension.',
  'beregning.avansert.rediger.radio.inntekt_vsa_gradert_uttak':
    'Do you expect to have income at the same time as you withdraw <nowrap>{grad} %</nowrap> pension?',
  'beregning.avansert.rediger.radio.inntekt_vsa_gradert_uttak.description':
    'You can earn as much as you want while withdrawing pension.',
  'beregning.avansert.rediger.radio.inntekt_vsa_gradert_uttak.ufoeretrygd.description':
    'retirement pension does not affect the income limit for your disability benefits.',
  'beregning.avansert.rediger.radio.inntekt_vsa_gradert_uttak.description.validation_error':
    'You must answer whether you expect to have income while you withdraw <nowrap>{grad} %</nowrap> pension.',
  'beregning.avansert.rediger.inntekt_vsa_gradert_uttak.beloep.validation_error':
    'You must fill in expected income at the same time as you withdraw <nowrap>{grad} %</nowrap> pension.',
  'beregning.avansert.rediger.radio.afp_inntekt_maaned_foer_uttak':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.afp_inntekt_maaned_foer_uttak.description':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.afp_inntekt_maaned_foer_uttak.validation_error':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.radio.inntekt_vsa_afp.validation_error':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_vsa_afp.validation_error':
    'MANGLER_TEKST',
  'beregning.avansert.rediger.inntekt_vsa_gradert_uttak.label':
    'What is your expected annual income while you withdraw <nowrap>{grad} %</nowrap> retirement pension?',
  'beregning.avansert.rediger.inntekt_vsa_gradert_uttak.description':
    'Current currency value before tax',
  'beregning.avansert.rediger.inntekt.button': 'Change Income',
  'beregning.avansert.rediger.agepicker.validation_error':
    ' for when you want to withdraw retirement pension.',
  'beregning.avansert.rediger.agepicker.grad.validation_error':
    ' for when you want to withdraw <nowrap>{grad} %</nowrap> retirement pension.',
  'beregning.avansert.rediger.agepicker.afp.validation_error': 'MANGLER_TEKST',
  'beregning.avansert.rediger.agepicker.validation_error.maxAlder':
    'Withdrawal age for <nowrap>100 %</nowrap> retirement pension must be later than age for graded pension.',
  'beregning.avansert.rediger.heltuttak.agepicker.label':
    'When will you take out <nowrap>100 %</nowrap> retirement pension?',
  'beregning.avansert.button.beregn': 'Calculate Pension',
  'beregning.avansert.button.beregn.endring': 'Calculate New Pension',
  'beregning.avansert.button.oppdater': 'Update Pension',
  'beregning.avansert.button.nullstill': 'Reset Choices',
  'beregning.avansert.button.avbryt': 'Cancel Change',
  'beregning.vilkaarsproeving.intro':
    'Your accrual is not high enough for the desired withdrawal. ',
  'beregning.vilkaarsproeving.intro.ikke_nok_opptjening':
    '{br}{br}You can earliest withdraw retirement pension at 67 years.',
  'beregning.vilkaarsproeving.intro.optional':
    'You need to increase the age or lower the withdrawal degree.{br}{br}',
  'beregning.vilkaarsproeving.alternativer.heltUttak':
    'One alternative is that you can withdraw <nowrap>100 %</nowrap> retirement pension at {alternativtHeltStartAar} years and {alternativtHeltStartMaaned} months. Feel free to try other combinations.',
  'beregning.vilkaarsproeving.alternativer.gradertUttak':
    'One alternative is that you can withdraw <nowrap>{alternativtGrad} %</nowrap> retirement pension at {alternativtGradertStartAar} years and {alternativtGradertStartMaaned} months. Feel free to try other combinations.',
  'beregning.vilkaarsproeving.alternativer.heltOgGradertUttak':
    'One alternative is that you can withdraw <nowrap>{alternativtGrad} %</nowrap> retirement pension at {alternativtGradertStartAar} years and {alternativtGradertStartMaaned} months if you withdraw <nowrap>100 %</nowrap> retirement pension at {alternativtHeltStartAar} years and {alternativtHeltStartMaaned} months or later. Feel free to try other combinations.',
  'beregning.vilkaarsproeving.medAFP.intro': 'MANGLER_TEKST',
  'beregning.vilkaarsproeving.alternativer.medAFP.gradertUttak':
    'MANGLER_TEKST',
  'beregning.vilkaarsproeving.alternativer.medAFP.heltOgGradertUttak':
    'MANGLER_TEKST',
  'beregning.vilkaarsproeving.alternativer.medAFP.heltOgGradertUttak100':
    'MANGLER_TEKST',
  'beregning.vilkaarsproeving.alternativer.medAFP.ikkeNokOpptjening':
    'MANGLER_TEKST',
  'grunnlag.title': 'Other Basis for Calculation',
  'grunnlag.endring.title': 'MANGLER_TEKST',
  'maanedsbeloep.title': 'MANGLER_TEKST',
  'beregning.avansert.avbryt_modal.title':
    'If you exit Advanced, you will lose all your choices.',
  'beregning.avansert.avbryt_modal.endring.title':
    'If you exit the calculation, you lose all your choices and return to the start.',
  'beregning.avansert.avbryt_modal.button.avslutt': 'Exit Advanced',
  'beregning.avansert.avbryt_modal.endring.button.avslutt': 'Exit calculation',
  'beregning.avansert.avbryt_modal.button.avbryt': 'Cancel',
  'beregning.avansert.alert.vilkaarsproevning.afp_inntekt_maaned_foer_uttak':
    'MANGLER_TEKST',
  'beregning.avansert.alert.afp_inntekt_maaned_foer_uttak': 'MANGLER_TEKST',
  'beregning.avansert.alert.afp_inntekt_maaned_foer_uttak.link.text':
    'MANGLER_TEKST',
  'beregning.endring.alert.uttaksdato':
    'You can earliest change the withdrawal degree to 20, 40, 50, 60, or 80 % from {dato}.',
  'beregning.endring.rediger.title': 'Calculate Change in retirement pension',
  'beregning.endring.rediger.vedtak_status':
    'From {dato} you have received {grad} % retirement pension.',
  'beregning.endring.rediger.vedtak_grad_status':
    'You currently have <strong><nowrap>{grad} %</nowrap> retirement pension</strong>. ',
  'beregning.endring.rediger.vedtak_betaling_status':
    'In {maaned}, this was <strong><nowrap>{beloep} kr</nowrap></strong> before tax.',
  'grunnlag.uttaksgrad.title': 'Withdrawal Degree',
  'grunnlag.uttaksgrad.avansert_link': 'Go to advanced calculator',
  'grunnlag.uttaksgrad.ingress':
    'This calculation shows <nowrap>100 %</nowrap> withdrawal of retirement pension. In the advanced calculator, you can calculate retirement pension with other withdrawal degrees (<nowrap>20 %</nowrap>, <nowrap>40 %</nowrap>, <nowrap>50 %</nowrap>, <nowrap>60 %</nowrap>, and <nowrap>80 %</nowrap>). You can work as much as you want alongside the pension even if you have taken out <nowrap>100 %</nowrap>.',
  'grunnlag.inntekt.title': 'Income Until Withdrawal',
  'grunnlag.inntekt.avansert_kalkulator':
    'You can add income alongside pension in ',
  'grunnlag.inntekt.avansert_link': 'advanced calculator',
  'grunnlag.inntekt.ingress':
    'Your last pensionable income from the Tax Administration is <nowrap>{beloep} kr</nowrap> from {aar}. See previous incomes in <dinPensjonBeholdningLink>Your pension accrual</dinPensjonBeholdningLink>. You can add income alongside pension in',
  'grunnlag.inntekt.ingress.endring':
    'Your last pensionable income from the Tax Administration is <nowrap>{beloep} kr</nowrap> from {aar}. See previous incomes in <dinPensjonBeholdningLink>Your pension accrual</dinPensjonBeholdningLink>',
  'grunnlag.inntekt.info_om_inntekt': 'What is Pensionable income?',
  'grunnlag.inntekt.info_om_inntekt.lukk': 'Close',
  'grunnlag.sivilstand.title': 'Marital Status',
  'grunnlag.sivilstand.title.error': 'Could not retrieve',
  'grunnlag.sivilstand.ingress':
    'The amount of your retirement pension may depend on whether you live alone or with someone. Therefore, if you receive retirement pension, you must inform Nav of any changes in marital status. {br}{br}<garantiPensjonLink>About guarantee pension and rates</garantiPensjonLink>',
  'grunnlag.opphold.title.mindre_enn_5_aar': 'Time Spent Outside Norway',
  'grunnlag.opphold.title.mer_enn_5_aar': 'Time Spent Outside Norway',
  'grunnlag.opphold.title.for_lite_trygdetid': 'Time in Norway',
  'grunnlag.opphold.title.endring': 'Time Spent Outside Norway',
  'grunnlag.opphold.value.mindre_enn_5_aar': '5 years or less',
  'grunnlag.opphold.value.mer_enn_5_aar': 'More than 5 years',
  'grunnlag.opphold.value.for_lite_trygdetid': 'Less than 5 years',
  'grunnlag.opphold.value.endring': 'From decision',
  'grunnlag.opphold.ingress.endre_opphold':
    'You can change your stays by going back to {link}.',
  'grunnlag.opphold.ingress.endre_opphold.link': 'Time Spent Outside Norway',
  'grunnlag.opphold.ingress.mindre_enn_5_aar':
    'The calculation assumes that you have not lived or worked outside Norway for more than 5 years from the age of 16 until you withdraw your pension.',
  'grunnlag.opphold.ingress.for_lite_trygdetid':
    'You have lived less than 5 years in Norway. Your calculation may be incomplete.',
  'grunnlag.opphold.ingress.endring':
    'The calculation uses the insurance time you have in Norway from your decision about retirement pension.',
  'grunnlag.opphold.ingress.trygdetid':
    'Your insurance time when starting the withdrawal of your pension: {aar} years{br}{br}<kortBotidLink>About insurance time</kortBotidLink>',
  'grunnlag.opphold.bunntekst':
    'When you apply for retirement pension, information about time spent outside Norway will be checked against pension authorities in agreement countries. Therefore, your final pension may differ.',
  'grunnlag.opphold.avbryt_modal.title':
    'If you go back to change your stays, you will lose all your choices in the calculation.',
  'grunnlag.opphold.avbryt_modal.bekreft': 'Go back to stays',
  'grunnlag.opphold.avbryt_modal.avbryt': 'Cancel',
  'grunnlag.alderspensjon.title': 'retirement pension',
  'grunnlag.alderspensjon.value': 'National Insurance Scheme (Nav)',
  'grunnlag.alderspensjon.ingress': 'MANLGER_TEKST',
  'grunnlag.alderspensjon.endring.ingress':
    'retirement pension is calculated based on your pension balance in the National Insurance Scheme. If you continue to have income while withdrawing pension, your retirement pension will increase.',
  'grunnlag.alderspensjon.endring.ingress.pensjonsbeholdning':
    '{br}{br}Your pension balance before withdrawal: {sum} kr',
  'grunnlag.alderspensjon.ingress.link':
    '{br}{br}<dinPensjonBeholdningLink>Your pension accrual</dinPensjonBeholdningLink> {br}{br}<alderspensjonsreglerLink>About the rules for retirement pension</alderspensjonsreglerLink>',
  'grunnlag.afp.title': 'AFP',
  'grunnlag.afp.ikke_beregnet': 'Not calculated',
  'grunnlag.afp.endring': 'Unchanged',
  'grunnlag.afp.ingress.null': '-',
  'grunnlag.afp.ingress.overgangskull': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.overgangskull.ufoeretrygd_eller_ap': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.ja_offentlig':
    'You have indicated AFP in the public sector. Nav has not assessed whether you meet the conditions for AFP, but assumes that you do. For more information on the conditions, check with your occupational pension scheme.',
  'grunnlag.afp.ingress.ja_offentlig.endring':
    'You have AFP in the public sector. Your AFP is not affected by your change in retirement pension. It continues as before.',
  'grunnlag.afp.ingress.ja_offentlig.ufoeretrygd': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.ja_offentlig_utilgjengelig': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.ja_privat':
    'You have indicated AFP in the private sector. Nav has not assessed whether you meet the criteria for AFP but assumes that you do. Some private sector employers may have agreements in the public sector. Check with your employer to see what applies to you. Read more about the AFP conditions and how to apply at <afpLink>Fellesordningen for AFP</afpLink>.',
  'grunnlag.afp.ingress.ja_privat.endring':
    'You have AFP in the private sector. Your AFP is not affected by your change in retirement pension. It continues as before.',
  'grunnlag.afp.ingress.ja_privat.ufoeretrygd': 'MANGLER_TEKST',
  'grunnlag.afp.ingress.vet_ikke':
    'If you are unsure whether you have AFP, you should ask your employer. AFP can affect when you can withdraw retirement pension.',
  'grunnlag.afp.ingress.vet_ikke.ufoeretrygd':
    'If you are unsure whether you have AFP, you should ask your employer. AFP and disability benefits cannot be combined, and if you receive disability benefits after turning 62, you lose the right to AFP. Therefore, you should check whether you have the right to AFP and choose between AFP and disability benefits before you are 62 years old.',
  'grunnlag.afp.ingress.nei':
    'If you start a job with an employer that has an AFP agreement, we recommend that you make a <goToStart>new calculation</goToStart>.',
  'grunnlag.afp.ingress.ufoeretrygd': 'MANGLER_TEKST',
  'grunnlag.afp.70prosentregel': 'MANGLER_TEKST',
  'grunnlag.afp.avkortet.til.70.prosent': 'MANGLER_TEKST',
  'grunnlag.afp.link.text': 'MANGLER_TEKST',
  'grunnlag.forbehold.ingress_1':
    'The pension has been calculated based on the information we have about you and the information you have provided. The calculation has been made in accordance with current regulations. This is a preliminary estimate of what you can expect to receive in pension. Nav is not responsible for the amounts obtained from other sources.',
  'grunnlag.forbehold.link': 'All reservations',
  'grunnlag.forbehold.title': 'Reservation',
  'savnerdunoe.title': 'Missing something?',
  'savnerdunoe.title.endring': 'MANGLER_TEKST',
  'savnerdunoe.ingress':
    'More choices for withdrawal degree, pension age, and income can be found in Advanced.',
  'savnerdunoe.ingress.endring': 'MANGLER_TEKST',
  'pensjonsavtaler.fra_og_med_forklaring':
    '“From” means “from and including.” “To” means “to and including.”',
  'pensjonsavtaler.private.title.ingen': 'Private pension agreements',
  'pensjonsavtaler.private.ingress.norsk_pensjon':
    'Agreements in the private sector are retrieved from <norskPensjonLink>Norsk Pensjon</norskPensjonLink>. Nav is not responsible for the amounts provided. You may have other agreements than those found in Norsk Pensjon. Contact the relevant pension scheme.',
  'pensjonsavtaler.private.ingress.error.pensjonsavtaler':
    'We could not retrieve your private pension agreements. Please try again later.',
  'pensjonsavtaler.private.ingress.error.pensjonsavtaler.partial':
    'We could not retrieve all your private pension agreements. Please try again later.',
  'pensjonsavtaler.ingress.error.samtykke_ingress':
    'You have not consented to retrieve pension agreements.',
  'pensjonsavtaler.ingress.error.samtykke_link_1': 'Start a new calculation',
  'pensjonsavtaler.ingress.error.samtykke_link_2':
    'if you want to include this in the calculation.',
  'pensjonsavtaler.ingress.ingen': 'We found no pension agreements.',
  'pensjonsavtaler.kr_pr_aar': 'kr per year',
  'alder.livsvarig': 'Lifelong from',
  'pensjonsavtaler.md': 'mo.',
  'pensjonsavtaler.tabell.title.left': 'Agreements',
  'pensjonsavtaler.tabell.title.middle': 'Periods',
  'pensjonsavtaler.tabell.title.right': 'Annual Amount',
  'pensjonsavtaler.til': 'to',
  'pensjonsavtaler.title': 'Pension Agreements',
  'pensjonsavtaler.offentligtp.title': 'Public Occupational Pension',
  'pensjonsavtaler.offentligtp.er_medlem_annen_ordning':
    'You are or have been employed in the public sector, but we unfortunately cannot retrieve public pension agreements. Check your pension agreements with the relevant occupational pension scheme ({chunk}).',
  'pensjonsavtaler.offentligtp.error':
    'We could not check whether you have public pension agreements. If you have been or are employed in the public sector, you can check your pension agreements with the relevant occupational pension scheme (e.g. Statens Pensjonskasse, Kommunal Landspensjonskasse, Oslo Pensjonsforsikring).',
  'pensjonsavtaler.offentligtp.teknisk_feil': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.empty':
    'We did not receive a response regarding your public service pension.',
  'pensjonsavtaler.offentligtp.subtitle.spk':
    'Retirement pension from the Norwegian Public Service Pension Fund (SPK)',
  'pensjonsavtaler.offentligtp.subtitle.klp': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.spk.afp_ja':
    'Lifelong AFP is not included in this amount. Check <spkLink>SPK</spkLink> for details about your pension agreement.',
  'pensjonsavtaler.offentligtp.spk.afp_nei.med_betinget':
    'You have stated that you are not entitled to lifelong AFP. Conditional occupational pension is therefore included in the amount. Check <spkLink>SPK</spkLink> for details.',
  'pensjonsavtaler.offentligtp.spk.afp_nei.uten_betinget':
    'You have stated that you are not entitled to lifelong AFP. Check <spkLink>SPK</spkLink> for details.',
  'pensjonsavtaler.offentligtp.spk.afp_vet_ikke':
    'You have stated that you are unsure if you are entitled to lifelong AFP. The amount may therefore include conditional occupational pension. Check <spkLink>SPK</spkLink> for details.',
  'pensjonsavtaler.offentligtp.klp.afp_ja': 'MANGLER_TEKST',
  'pensjonsavtaler.offentligtp.klp.afp_nei+vetikke': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_modal.open.button': 'Change Income',
  'inntekt.endre_inntekt_modal.title': 'Pensionable income',
  'inntekt.endre_inntekt_modal.textfield.label':
    'What is your expected annual income until you withdraw pension?',
  'inntekt.endre_inntekt_modal.textfield.description':
    'Current currency value before tax',
  'inntekt.endre_inntekt_modal.textfield.description.ufoere':
    'Not disability benefits and disability pension. Current currency value before tax',
  'inntekt.endre_inntekt_modal.paragraph':
    'When you update your income, you must choose age again.',
  'inntekt.endre_inntekt_modal.textfield.validation_error.required':
    'You must fill in income.',
  'inntekt.endre_inntekt_modal.textfield.validation_error.type':
    'You must write whole numbers to specify income.',
  'inntekt.endre_inntekt_modal.textfield.validation_error.max':
    'Income cannot exceed 100,000,000 kroner.',
  'inntekt.endre_inntekt_modal.button': 'Update Income',
  'inntekt.endre_inntekt_vsa_pensjon_modal.label':
    'Expected Annual Income while withdrawing <nowrap>100 %</nowrap> retirement pension',
  'inntekt.endre_inntekt_vsa_pensjon_modal.ingress_2':
    'You can earn as much as you want while withdrawing <nowrap>100 %</nowrap> retirement pension.',
  'inntekt.endre_inntekt_vsa_pensjon_modal.open.button.legg_til': 'Add Income',
  'inntekt.endre_inntekt_vsa_pensjon_modal.open.button.endre': 'Change Income',
  'inntekt.endre_inntekt_vsa_pensjon_modal.button.slette': 'Delete Income',
  'inntekt.endre_inntekt_vsa_pensjon_modal.title': 'Pensionable income',
  'inntekt.endre_inntekt_vsa_pensjon_modal.textfield.label':
    'What is your expected annual income while withdrawing <nowrap>100 %</nowrap> retirement pension?',
  'inntekt.endre_inntekt_vsa_afp_modal.textfield.label': 'MANGLER_TEKST',
  'inntekt.endre_inntekt_vsa_pensjon_modal.textfield.description':
    'Current currency value before tax',
  'inntekt.endre_inntekt_vsa_pensjon_modal.agepicker.label':
    'Until which age do you expect to have the income?',
  'inntekt.endre_inntekt_vsa_pensjon_modal.button.legg_til': 'Add Income',
  'inntekt.endre_inntekt_vsa_pensjon_modal.button.endre': 'Update Income',
  'inntekt.info_om_inntekt.open.link': 'What is Pensionable income?',
  'inntekt.info_om_inntekt.intro':
    'We use the last available annual income from the Tax Administration as future income. If you change it in the calculator, we will use that instead.{br}{br}',
  'inntekt.info_om_inntekt.subtitle_1': 'This is Pensionable income:',
  'inntekt.info_om_inntekt.list_item1': 'all wage income for employees',
  'inntekt.info_om_inntekt.list_item2':
    'personal income from business for the self-employed',
  'inntekt.info_om_inntekt.list_item3': 'parental benefits',
  'inntekt.info_om_inntekt.list_item4': 'sickness benefits',
  'inntekt.info_om_inntekt.list_item5': 'benefits for unemployment',
  'inntekt.info_om_inntekt.list_item6': 'employment clarification benefits',
  'inntekt.info_om_inntekt.list_item7': 'adjustment benefit',
  'inntekt.info_om_inntekt.list_item8': 'care benefits',
  'inntekt.info_om_inntekt.list_item9':
    'foster care compensation (the part that constitutes work compensation)',
  'inntekt.info_om_inntekt.subtitle_2': 'This is not Pensionable income:',
  'inntekt.info_om_inntekt.ikke_inntekt.list_item1':
    'disability benefits from Nav provide accrual for retirement pension but are not Pensionable income',
  'inntekt.info_om_inntekt.ikke_inntekt.list_item2':
    'disability pensions and other pensions from occupational pension schemes',
  'inntekt.info_om_inntekt.ikke_inntekt.list_item3':
    'income and pension from abroad',
  'inntekt.info_om_inntekt.ikke_inntekt.list_item4':
    'Norwegian armed forces (if started no earlier than 2010) provides accrual for retirement pension but is not Pensionable income',
  'inntekt.info_om_inntekt.ingress':
    'This list is not exhaustive.{br}{br}Pensionable income matters for the right to and the amount of retirement pension and other pension benefits.',
  'forbehold.title': 'Reservation',
  'personopplysninger.header':
    'Personal information used in the pension calculator',
  'personopplysninger.section.formaal.header':
    'What is the purpose of the personal information?',
  'personopplysninger.section.formaal.1':
    'Nav collects personal information in the calculator to allow you to plan your pension and get an estimate of your future pension.',
  'personopplysninger.section.formaal.2':
    'You must log in to use the calculator. To calculate the retirement pension, we use the information you provide in the calculator, the information Nav has about you, and the necessary information from other public agencies. If you consent, we retrieve pension agreements from other pension providers to give you a comprehensive overview of your pension.',
  'personopplysninger.section.hvordan_brukes.header':
    'How do we process personal information?',
  'personopplysninger.section.hvordan_brukes.1':
    'Nav collects and discloses personal information only when we have a legal basis for it. If we need additional information, we request your consent to obtain or disclose the information. We use the information only for what you consent to. Consent is voluntary. You will be informed along the way about the information we collect from others, such as the Population Register and pension providers.',
  'personopplysninger.section.hvordan_brukes.2':
    'We do not store the calculations you make or the personal information used in the processing.',
  'personopplysninger.section.hvordan_brukes.3':
    'The legal basis for the processing of pension simulations is Art. 6 (1) c Legal obligation, Administration Act § 11, National Insurance Act Chapter 20 Retirement Pension, and Art. 6 (1) a Consent. Nav is the data controller for the processing performed in the pension calculator.',
  'personopplysninger.section.hvilke_opplysninger.header':
    'What personal information do we use?',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.header':
    'Information we collect to fulfil Nav’s duty to provide guidance under Art. 6 (1) c Legal obligation, Administration Act § 11.',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.1':
    'Your national identity number is retrieved from the ID portal to identify you.',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.2':
    'Your name is retrieved from the Population Register to clarify that the calculation applies to you.',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.3':
    'Your date of birth is retrieved from the Population Register so we can calculate your retirement pension.',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.4':
    'The desired age (year and possibly month) for pension withdrawal is provided by you to calculate your retirement pension.',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.5':
    'Your pension accrual is retrieved from the pension accrual register at Nav, which is based on income reported by the Tax Administration, as well as any accrual from unemployment benefits, military service, caregiving accrual, and accrual from disability benefits.',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.6':
    'Your latest pensionable annual income (and year) from the Tax Administration is used as income until the pension withdrawal. It is included in the pension balance for calculating your retirement pension. If you change your future income, your future pension balance will be based on that.',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.7':
    'Your marital status can affect the size of your pension. Information about your marital status is retrieved from the Population Register. If you are registered as single, separated, divorced, or widowed, we ask if you have a cohabitant. Changes you make only apply to that calculation and are not stored by Nav or the Population Register.',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.8':
    'If you receive disability benefits, we use your disability history, degree of disability, estimated income, and any occupational injury history to calculate your retirement pension. We also use the degree of disability to show possible graduations of retirement pension you can withdraw in combination with disability benefits. We do not retrieve medical information from your case.',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.9':
    'If you receive a survivor’s pension or transitional benefit, we use the information to inform you that survivor’s pension and transitional benefit cannot be combined with retirement pension.',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.10':
    'We ask if you have resided outside Norway. We use the information to calculate retirement pension with the correct insurance period in Norway. We ask which country the stay applies to and about work in the country to apply the correct insurance agreement.',
  'personopplysninger.section.hvilke_opplysninger.veiledningsplikt.list.11':
    'We ask if you are entitled to AFP in either the public or private sector. We use the information to determine whether to calculate your retirement pension with AFP. The information is also used to inform you of when you can withdraw your retirement pension. Furthermore, we use the information to calculate AFP in the private sector.',
  'personopplysninger.section.hvilke_opplysninger.gpdr.list.header':
    'Information we use if you consent (GDPR Art. 6 (1) a Consent).',
  'personopplysninger.section.hvilke_opplysninger.gpdr.list.1':
    'From Norsk Pensjon, we retrieve pension agreements from the private sector, such as occupational pensions from employers (defined contribution, defined benefit, or hybrid pensions), paid-up policies, and some pension savings agreements.',
  'personopplysninger.section.hvilke_opplysninger.gpdr.list.2':
    'We also check if you are or have been a member of a public occupational pension scheme. If you are or have been a member, we inform you that you may have entitlements but do not retrieve the agreements.',
  'personopplysninger.section.hvilke_opplysninger.gpdr.list.3':
    'We calculate AFP in the public sector based on your AFP balance if you consent.',
  'personopplysninger.section.hvilke_opplysninger.gpdr.list.subtext':
    'We collect this information to give you an overview of your total pension.',
  'personopplysninger.section.lagring.heading': 'Storage',
  'personopplysninger.section.lagring.text':
    'There is temporary storage in the pension calculator to perform a pension calculation. When you finish the calculation or log out, the temporary storage is deleted. Your calculation is not stored or archived by Nav.',
  'personopplysninger.section.informasjon_om_rettighetene.heading':
    'Information about your rights',
  'personopplysninger.section.informasjon_om_rettighetene.text':
    'See <navPersonvernerklaeringLink>the privacy policy</navPersonvernerklaeringLink> for Nav.',
  'personopplysninger.section.spoersmaal.heading':
    'Questions for Nav or the Data Protection Authority about privacy',
  'personopplysninger.section.spoersmaal.text':
    'See contact information in <navPersonvernerklaeringKontaktOssLink>the privacy policy</navPersonvernerklaeringKontaktOssLink> for Nav.',
  'showmore.vis_mindre': 'Show less',
  'showmore.vis_mer': 'Show more',
  'link.telefon_pensjon': '55 55 33 34',
}
